import React from 'react'
import styled from 'styled-components'
import { Menu, MenuItem, IconButton, Spinner } from 'react-mdl'
import Button from '../../../../components/Button'
import Editor from '../../../../components/Editor'
import ScrollingDialog from '../../../../components/ScrollingDialog'

import QuestionMultipleChoiceOptions from './QuestionMultipleChoiceOptions'

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0 0.25em;
  }
`
const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`



export default function QuestionContentDialog({
  goBack,
  onSave,
  onDelete,
  canDelete,
  onChangeQuestionType,
  onChangeQuestionText,
  onChangeAnswer,
  onChangeLearnerAnswerSection,
  onChangeScenario,
  onChangeMultiChoiceOption,
  onAddMultiChoiceOption,
  displaySpinner,
  questionType,
  content: { questionText, answer, learnerAnswerSection, scenario, multiChoiceOptions },
}) {

  function typeToTitle(questionType) {
    switch(questionType) {
      case 'review': return 'Review Question';
      case 'final': return 'Final Theory Question';
      case 'review-multi': return 'Multiple Choice Review Question';
      case 'final-multi': return 'Multiple Choice Final Theory Question';
      default: return 'Final Theory Question'
    }
  }

  function isMultipleChoice(questionType) {
    return questionType.indexOf('-multi') > 0
  }

  return (
    <ScrollingDialog>
      <Header>
        <h3>Question</h3>
        <div>
          <Button id="question-type-selector">
            {typeToTitle(questionType)}
          </Button>
          <Menu target="question-type-selector">
            <MenuItem onClick={() => onChangeQuestionType('review')}>
              Review Question
            </MenuItem>
            <MenuItem onClick={() => onChangeQuestionType('final')}>
              Final Theory Question
            </MenuItem>
            <MenuItem onClick={() => onChangeQuestionType('review-multi')}>
              Multiple Choice Review Question
            </MenuItem>
            <MenuItem onClick={() => onChangeQuestionType('final-multi')}>
              Multiple Choice Final Theory Question
            </MenuItem>
          </Menu>
          <IconButton name="close" onClick={goBack} />
        </div>
      </Header>
      <div>
        <h4>Question</h4>
        <Editor onChange={onChangeQuestionText} state={questionText} />
      </div>
      {isMultipleChoice(questionType) ?
        <div>
          <h4>Model Answer</h4>
          <QuestionMultipleChoiceOptions state={multiChoiceOptions} onChange={onChangeMultiChoiceOption} />
          <Button raised primary onClick={onAddMultiChoiceOption}>
            Add Option
          </Button>
        </div>
        :
        <div>
          <div>
            <h4>Model Answer</h4>
            <Editor onChange={onChangeAnswer} state={answer} />
          </div>
          <div>
            <h4>Answer Area for Learners</h4>
            <Editor
              onChange={onChangeLearnerAnswerSection}
              state={learnerAnswerSection}
            />
          </div>
        </div>
      }

      <div>
        <h4>Additional Information (Optional)</h4>
        <Editor onChange={onChangeScenario} state={scenario} />
      </div>
      <ActionsContainer>
        {canDelete
          ? <Button onClick={onDelete} accent>
            Delete
            </Button>
          : <div />}
        {displaySpinner
          ? <Spinner />
          : <Button onClick={onSave} raised primary>
            Save
            </Button>}
      </ActionsContainer>
    </ScrollingDialog>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/QuestionContentDialog.js